import React, {Component, PropTypes} from 'react';
import { RequiredLabel, InlineWarning, errorUtilities } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './int-element.style.js';

export class IntElement extends Component {
  handleInput(e) {
    const { onChange } = this.props;
    const value = e.target.value;
    var numberOnly = value.replace(/\D/g, '');
    onChange(numberOnly);
  }

  getValue() {
    const { response, defaultValue } = this.props;
    return response ? response : defaultValue ? defaultValue : "";
  }

  render() {
    const { isRequired, label, id, response, disabled, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');
    const inlineErrors = errors && errors.filter(err => err.type === errorUtilities.errorTypes.inline);

    return (
      <div className={css.group + ' validated-section'}>
        <RequiredLabel
          hasErrors={hasErrors && showErrors}
          htmlFor={id}
          content={label}
          isRequired={isRequired}
          css={{requiredLabel: css.label}}/>
        <div className={css.displayWrapper}>
          <input
            id={id}
            type="text"
            value={this.getValue()}
            onChange={e => this.handleInput(e)}
            className={css.input + ' validated-input'}
            disabled={disabled}
            aria-required={isRequired}
            aria-invalid={hasErrors && showErrors}
            aria-describedby={errorIds} />
          {inlineErrors && inlineErrors.map(warn => (
            <InlineWarning key={warn.id} warn={!!response ? warn.errorMessage : null}/>
          ))}
        </div>
      </div>
    );
  }
}

IntElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (IntElement);



// WEBPACK FOOTER //
// src/common/form-elements/int-element-folder/int-element.js